import React from "react";
import {
    FiMapPin,
    FiPhone,
    FiMail,
    FiClock,
    FiSend,
    FiFacebook,
    FiInstagram,
    FiTwitter,
    FiLinkedin,
} from "react-icons/fi";

const ContactUs = () => {
    return (
        <>
            {/* Hero Section */}
            <div
                className="py-5"
                style={{
                    background: "linear-gradient(135deg, #1a4d2e 0%, #2e7d32 100%)",
                }}
            >
                <div className="container py-5 text-center text-white">
                    <h1 className="display-4 fw-bold mb-3">Get in Touch</h1>
                    <p className="fs-5 opacity-75 mb-0">
                        We’d love to hear from you. Let’s work together.
                    </p>
                </div>
            </div>

            {/* Contact Cards */}
            <div className="container" style={{ marginTop: "-60px" }}>
                <div className="row g-4">
                    {[
                        {
                            icon: <FiMapPin size={22} />,
                            title: "Visit Us",
                            text: "Shop No.:11, Bazar Samiti Yard Sandha Chapra – 841301 (Bihar)",
                            
                          
                        },
                        {
                            icon: <FiPhone size={22} />,
                            title: "Call Us",
                            text: "+91 9431812596",
                        },
                        {
                            icon: <FiMail size={22} />,
                            title: "Email Us",
                            text: "hindustanfruits@yahoo.co.in",
                        },
                        {
                            icon: <FiClock size={22} />,
                            title: "Working Hours",
                            text: "Mon-Fri: 9AM - 6PM",
                        },
                    ].map((item, index) => (
                        <div className="col-md-3 col-6" key={index}>
                            <div
                                className="card border-0 shadow-lg h-100 text-center"
                                style={{
                                    borderRadius: "20px",
                                    padding: "30px",
                                    backgroundColor: "var(--color-surface)",
                                }}
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center mb-3"
                                    style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "50%",
                                        background:
                                            "linear-gradient(135deg, #1a4d2e, #20c997)",
                                        color: "#fff",
                                        margin: "0 auto",
                                    }}
                                >
                                    {item.icon}
                                </div>

                                <h6 className="fw-bold mb-2">{item.title}</h6>
                                <p className="text-muted mb-0 small">{item.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Form + Map Section */}
            <div className="container py-5">
                <div className="row g-5">
                    {/* Contact Form */}
                    <div className="col-lg-7">
                        <div
                            className="card border-0 shadow"
                            style={{ borderRadius: "24px" }}
                        >
                            <div className="card-body p-5">
                                <h3 className="fw-bold mb-4">Send Message</h3>

                                <form>
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="Your Name"
                                                style={{
                                                    padding: "16px",
                                                    borderRadius: "12px",
                                                }}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <input
                                                type="email"
                                                className="form-control form-control-lg"
                                                placeholder="Email Address"
                                                style={{
                                                    padding: "16px",
                                                    borderRadius: "12px",
                                                }}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <input
                                                type="tel"
                                                className="form-control form-control-lg"
                                                placeholder="Phone Number"
                                                style={{
                                                    padding: "16px",
                                                    borderRadius: "12px",
                                                }}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <select
                                                className="form-select form-select-lg"
                                                style={{
                                                    padding: "16px",
                                                    borderRadius: "12px",
                                                }}
                                                defaultValue=""
                                            >
                                                <option value="" disabled>
                                                    Select Country
                                                </option>
                                                <option>India</option>
                                                <option>UAE</option>
                                                <option>USA</option>
                                                <option>UK</option>
                                                <option>Singapore</option>
                                            </select>
                                        </div>

                                        <div className="col-12">
                                            <input
                                                type="text"
                                                className="form-control form-control-lg"
                                                placeholder="Subject"
                                                style={{
                                                    padding: "16px",
                                                    borderRadius: "12px",
                                                }}
                                            />
                                        </div>

                                        <div className="col-12">
                                            <textarea
                                                className="form-control form-control-lg"
                                                rows="4"
                                                placeholder="Your Message"
                                                style={{
                                                    padding: "16px",
                                                    borderRadius: "12px",
                                                }}
                                            ></textarea>
                                        </div>

                                        <div className="col-12">
                                            <button
                                                type="submit"
                                                className="btn btn-lg w-100 text-white d-flex align-items-center justify-content-center gap-2"
                                                style={{
                                                    background:
                                                        "linear-gradient(135deg, #1a4d2e, #20c997)",
                                                    padding: "16px",
                                                    borderRadius: "12px",
                                                    border: "none",
                                                }}
                                            >
                                                <FiSend />
                                                Send Message
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Map & Info */}
                    <div className="col-lg-5">
                        <div
                            className="card border-0 shadow h-100"
                            style={{ borderRadius: "24px" }}
                        >
                            <div className="card-body p-5">
                                <h3 className="fw-bold mb-4">Our Location</h3>

                                {/* Map */}
                                <div
                                    className="rounded-4 overflow-hidden mb-4"
                                    style={{ height: "200px" }}
                                >
                                    <iframe
                                        src="https://www.google.com/maps?q=Sarkari+Bazar,+Chapra,+Bihar+841301&output=embed"
                                        width="100%"
                                        height="100%"
                                        style={{ border: 0 }}
                                        loading="lazy"
                                        title="Hindustan Fruit & Vegetable Co. Location"
                                    ></iframe>

                                </div>

                                {/* Social Links */}
                                <h5 className="fw-semibold mb-3">Follow Us</h5>
                                <div className="d-flex gap-3">
                                    {[FiFacebook, FiInstagram, FiTwitter, FiLinkedin].map(
                                        (Icon, index) => (
                                            <button
                                                key={index}
                                                className="btn border-0 d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: "45px",
                                                    height: "45px",
                                                    borderRadius: "50%",
                                                    backgroundColor: "#f1f3f5",
                                                }}
                                            >
                                                <Icon size={18} />
                                            </button>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div
                className="py-5 text-center text-white"
                style={{
                    background: "linear-gradient(135deg, #1a4d2e, #20c997)",
                }}
            >
                <div className="container">
                    <h2 className="fw-bold mb-3">Ready to Start Importing?</h2>
                    <p className="opacity-75 mb-4">
                        Get in touch with our export team today
                    </p>
                    <button
                        className="btn btn-light btn-lg px-5 py-3 fw-semibold"
                        style={{
                            borderRadius: "12px",
                            color: "var(--color-primary)",
                        }}
                    >
                        Request a Quote
                    </button>
                </div>
            </div>
        </>
    );
};

export default ContactUs;
